module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxNiAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgMTBMMC41IDIwTDAuNTAwMDAxIC02LjU1NjcxZS0wN0wxNS41IDEwWiIgZmlsbD0iIzdDN0M3QyIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/icon--arrow-ky-right-1.svg
// module id = 13883
// module chunks = 0